import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useMediaQuery } from "@mui/material";


export const ThemeContext = React.createContext();

export default function ThemeContextProvider({ children }) {
    const isMobileScreen = useMediaQuery('(max-width:600px)');
    const [drawerShow, setDrawerShow] = useState(!isMobileScreen)
    const [darkTheme, setDarkTheme] = useState(false)
    // drawer menu
    const [listoggle, setListToggle] = useState({})
    const [sublistoggle, setSubListToggle] = useState({})
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 20,
    });
    return (
        <ThemeContext.Provider
            value={{
                isMobileScreen,
                drawerShow,
                setDrawerShow,
                darkTheme,
                setDarkTheme,
                listoggle,
                setListToggle,
                sublistoggle,
                setSubListToggle, paginationModel, setPaginationModel
            }}
        >
            {children}
        </ThemeContext.Provider>
    )
}


ThemeContextProvider.propTypes = {
    children: PropTypes.any,
};